import React from 'react';
import { Stack } from '@fluentui/react';
import { Dismiss16Regular } from '@fluentui/react-icons';
import { useAppTheme } from 'common';
import { IconButton } from 'common/components/Buttons/v8';
import { pageDataService } from 'common/utilities';
import { useLocalizedStrings } from 'i18n';

import { IDialogCardCloseButtonProps } from './DialogCard.Props';
import { iconButtonStyles, useDialogStyles } from './DialogCard.styles';

export const DialogCardCloseButton: React.FunctionComponent<IDialogCardCloseButtonProps> = (props: IDialogCardCloseButtonProps) => {
  const { onCloseClick, closeAriaLabel } = props;
  const theme = useAppTheme();
  const styles = useDialogStyles();
  const { t } = useLocalizedStrings(); // using default namespace
  const isRtl = pageDataService.isRtlLocale();
  const CancelIcon = <Dismiss16Regular />;
  return (
    <Stack.Item grow={false} align={isRtl ? 'start' : 'end'} className={styles.closeButtonWrapper}>
      <IconButton
        ariaLabel={closeAriaLabel ?? t('Close')}
        styles={iconButtonStyles(theme)}
        onClick={typeof onCloseClick === 'function' ? onCloseClick : undefined}
        {...(typeof onCloseClick !== 'function' ? onCloseClick : undefined)}
        onRenderIcon={() => CancelIcon}
      />
    </Stack.Item>
  );
};
